import { apiSlice } from "@/shared/api/api-slice"
import type { GetTriggersResponse, UpsertTriggersRequest } from "@/shared/types/api/business-mode.types"

const businessTriggersApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessTriggers"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      getBusinessTriggers: builder.query<GetTriggersResponse, number>({
        query: userId => `/api/v1/business-mode/triggers?user_id=${userId}`,
        providesTags: ["BusinessTriggers"]
      }),
      upsertBusinessTriggers: builder.mutation<undefined, { userId: number; data: UpsertTriggersRequest }>({
        query: ({ userId, data }) => ({
          url: `/api/v1/business-mode/triggers`,
          method: "PUT",
          body: { ...data, user_id: userId }
        }),
        invalidatesTags: (_result, error) => (error ? [] : ["BusinessTriggers"])
      }),
      deleteBusinessTriggers: builder.mutation<undefined, number>({
        query: userId => ({
          url: `/api/v1/business-mode/triggers`,
          method: "DELETE",
          params: { user_id: userId }
        }),
        invalidatesTags: ["BusinessTriggers"]
      })
    })
  })

export const { useGetBusinessTriggersQuery, useUpsertBusinessTriggersMutation, useDeleteBusinessTriggersMutation } =
  businessTriggersApi
